/**
 * A leave year runs from the 1st of the company's start month to the day before it a year later,
 * and is named by the year it starts in. With January it is the calendar year.
 */
export function leaveYearOf(day: string, startMonth: number): number {
  const year = Number(day.slice(0, 4));
  return Number(day.slice(5, 7)) < startMonth ? year - 1 : year;
}

/** A leave year's first and last day, as `yyyy-mm-dd`. */
export function leaveYearSpan(
  year: number,
  startMonth: number,
): { startsOn: string; endsOn: string } {
  const month = String(startMonth).padStart(2, "0");
  // Day 0 of a month is the last day of the one before it.
  const endsOn = new Date(Date.UTC(year + 1, startMonth - 1, 0))
    .toISOString()
    .slice(0, 10);
  return { startsOn: `${year}-${month}-01`, endsOn };
}
